exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-slide[data-v-46aa68e4]{width:250px}.carousel-image[data-v-46aa68e4]{width:auto;height:auto;-o-object-fit:cover;object-fit:cover}.websites-section a[data-v-46aa68e4]{width:-moz-fit-content;width:fit-content;font-size:33px;font-weight:300}", ""]);

// exports
